var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.23077C4.26146 1.23077 1.23077 4.26146 1.23077 8C1.23077 11.7385 4.26146 14.7692 8 14.7692C11.7385 14.7692 14.7692 11.7385 14.7692 8C14.7692 4.26146 11.7385 1.23077 8 1.23077ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99993 4.92315C6.64045 4.92315 5.53839 6.02522 5.53839 7.38469C5.53839 8.74416 6.64045 9.84623 7.99993 9.84623C9.3594 9.84623 10.4615 8.74416 10.4615 7.38469C10.4615 6.02522 9.3594 4.92315 7.99993 4.92315ZM4.30762 7.38469C4.30762 5.34549 5.96072 3.69238 7.99993 3.69238C10.0391 3.69238 11.6922 5.34549 11.6922 7.38469C11.6922 9.4239 10.0391 11.077 7.99993 11.077C5.96072 11.077 4.30762 9.4239 4.30762 7.38469Z",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99978 11.0765C7.09064 11.0765 6.19925 11.3282 5.42442 11.8038C4.6496 12.2794 4.0216 12.9603 3.61004 13.7709C3.45618 14.074 3.08579 14.1949 2.78274 14.041C2.47969 13.8872 2.35874 13.5168 2.5126 13.2137C3.02705 12.2004 3.81205 11.3494 4.78058 10.7549C5.74912 10.1604 6.86335 9.8457 7.99978 9.8457C9.13621 9.8457 10.2504 10.1604 11.219 10.7549C12.1875 11.3494 12.9725 12.2004 13.487 13.2137C13.6408 13.5168 13.5199 13.8872 13.2168 14.041C12.9138 14.1949 12.5434 14.074 12.3895 13.7709C11.978 12.9603 11.35 12.2794 10.5751 11.8038C9.80031 11.3282 8.90892 11.0765 7.99978 11.0765Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonInput);
export default __webpack_public_path__ + "static/media/icon_person-input.566fdd2820a085f450afcebff5053b8e.svg";
export { ForwardRef as ReactComponent };